import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import './RegistrationForm.css';
import { config } from '../../../../config';
import AgreementModal from './AgreementModal';
import { CUSTOMER_AGREEMENT } from '../../../../content/userAgreement';

const RegistrationForm = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [agreementOpen, setAgreementOpen] = useState(false);
    const [agreementAccepted, setAgreementAccepted] = useState(false);
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        contactNumber: "",
        addressStreet: "",
        addressCity: "",
        addressState: "",
        addressZip: "",
        successMessage: null
    })

    const handleChange = (e) => {
        const { id, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [id]: value
        }));
    }

    const sendDetailsToServer = () => {
        if (state.email && state.password && state.firstName && state.lastName && state.contactNumber.trim()) {
            const payload = {
                email: state.email,
                password: state.password,
                firstname: state.firstName,
                lastname: state.lastName,
                contactNumber: state.contactNumber.trim(),
                address: {
                    street: state.addressStreet,
                    city: state.addressCity,
                    state: state.addressState,
                    zip: state.addressZip
                },
                role: 'CUSTOMER',
                acceptedTerms: true,
                termsVersion: CUSTOMER_AGREEMENT.version
            };
            setLoading(true);
            axios.post(`${config.API_BASE}/api/signup`, payload)
                .then(function (response) {
                    console.log('Signup response:', response.data);
                    if (response.status === 200 || response.status === 201) {
                        alert('Registration successful! Please sign in to continue.');
                        navigate('/account/signin');
                    } else {
                        alert("Some error occurred");
                    }
                })
                .catch(function (error) {
                    const message = error.response?.data?.error
                      || error.response?.data?.message
                      || 'Registration failed';
                    alert(message);
                    console.log(error);
                })
                .finally(function () {
                    setLoading(false);
                });
        } else {
            alert('Please fill all required fields, including your contact number.');
        }
    }

    const redirectToLogin = () => {
        navigate('/account/signin');
    }

    const handleSubmitClick = (e) => {
        e.preventDefault();
        if (!agreementAccepted) {
            alert('Please read and accept the user agreement to continue.');
            return;
        }
        if (state.password === state.confirmPassword) {
            sendDetailsToServer();
        } else {
            alert('Passwords do not match');
        }
    }

    return (
        <div className="signup-container">
            <div className="signup-card">
                <div className="signup-header">
                    <h1 className="signup-title">Farmers Marketspace</h1>
                    <p className="signup-subtitle">Customer Portal</p>
                </div>

                <h2 className="signup-heading">Create an Account</h2>

                <form onSubmit={handleSubmitClick} className="signup-form">
                    <div className="signup-form-group">
                        <label htmlFor="firstName" className="signup-label">First Name</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="firstName"
                            placeholder="First Name"
                            value={state.firstName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="lastName" className="signup-label">Last Name</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="lastName"
                            placeholder="Last Name"
                            value={state.lastName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="email" className="signup-label">Email</label>
                        <input
                            type="email"
                            className="signup-input"
                            id="email"
                            placeholder="Email"
                            value={state.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="password" className="signup-label">Password</label>
                        <input
                            type="password"
                            className="signup-input"
                            id="password"
                            placeholder="Password"
                            value={state.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="confirmPassword" className="signup-label">Confirm Password</label>
                        <input
                            type="password"
                            className="signup-input"
                            id="confirmPassword"
                            placeholder="Confirm Password"
                            value={state.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="contactNumber" className="signup-label">Contact Number</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="contactNumber"
                            placeholder="Contact Number"
                            value={state.contactNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="addressStreet" className="signup-label">Street Address</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="addressStreet"
                            placeholder="Street Address"
                            value={state.addressStreet}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="addressCity" className="signup-label">City</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="addressCity"
                            placeholder="City"
                            value={state.addressCity}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="addressState" className="signup-label">State</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="addressState"
                            placeholder="State"
                            value={state.addressState}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="signup-form-group">
                        <label htmlFor="addressZip" className="signup-label">Zip Code</label>
                        <input
                            type="text"
                            className="signup-input"
                            id="addressZip"
                            placeholder="Zip Code"
                            value={state.addressZip}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="signup-agreement">
                        <div className="signup-agreement-check">
                            {/* Ticking is only possible by agreeing in the modal, so the
                                document has to be opened and read first. Unticking stays
                                available so consent can be withdrawn. */}
                            <input
                                type="checkbox"
                                id="agreement"
                                checked={agreementAccepted}
                                disabled={!agreementAccepted}
                                aria-label={`I have read and agree to ${CUSTOMER_AGREEMENT.title}`}
                                onChange={(e) => setAgreementAccepted(e.target.checked)}
                            />
                            <span className="signup-agreement-label">
                                I have read and agree to{' '}
                                <button
                                    type="button"
                                    className="signup-agreement-open"
                                    onClick={() => setAgreementOpen(true)}
                                >
                                    {CUSTOMER_AGREEMENT.title}
                                </button>
                                .
                            </span>
                        </div>
                        {!agreementAccepted && (
                            <p className="signup-agreement-hint">
                                Open the agreement and read to the end to continue.
                            </p>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="signup-button"
                        disabled={loading || !agreementAccepted}
                    >
                        {loading ? "Creating..." : "Create Account"}
                    </button>
                </form>

                <div className="signup-footer">
                    <span className="signup-footer-text">Already have an account? </span>
                    <button
                        className="signup-link"
                        onClick={redirectToLogin}
                        type="button"
                    >
                        Back to Sign In
                    </button>
                </div>
            </div>

            <AgreementModal
                agreement={CUSTOMER_AGREEMENT}
                isOpen={agreementOpen}
                onClose={() => setAgreementOpen(false)}
                onAgree={() => setAgreementAccepted(true)}
            />
        </div>
    )
}

export default RegistrationForm;
